function setMobileView() {
    const resizing = el => {
        const items = el.querySelectorAll(".boxedItem--noHeading");
        let checkTextLen = [];

        items.forEach(item => {
            checkTextLen.push(item.textContent.trim().length < 25);
        });

        if (!checkTextLen.includes(false)) {
            items.forEach(item => {
                const parent = item.closest(".list__item");
                const isMobileView = window.innerWidth < 768;
                const isTabletView = window.innerWidth < 1025 && window.innerWidth >= 768;

                if (isMobileView) {
                    parent.classList.add("list__item--boxedItemHalf");
                    parent.classList.remove("list__item--boxedItemThird");
                } else if (isTabletView) {
                    parent.classList.remove("list__item--boxedItemHalf");
                    parent.classList.add("list__item--boxedItemThird");
                } else {
                    parent.classList.remove("list__item--boxedItemThird");
                    parent.classList.remove("list__item--boxedItemHalf");
                }
            });
        }
    };

    document.querySelectorAll(".list__items").forEach(el => {
        resizing(el);

        window.addEventListener("resize", function() {
            resizing(el);
        });
    });
}

export default { setMobileView };
